import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { List } from 'immutable';
import { BaseEntity, BaseInline2Container, BaseInlineContainer, InlineContainerService, UserService } from 'yt-ng-framework';

@Component({
  selector: 'yt-instrukcija-placanja-update-container',
  templateUrl: './instrukcija-placanja-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})

export class InstrukcijaPlacanjaUpdateContainerComponent<T extends BaseEntity> extends BaseInline2Container<T> implements OnInit {

  constructor(inlineContainerService: InlineContainerService<T>
              ){
  super(inlineContainerService);
  }

//   constructor(inlineContainerService: InlineContainerService<T>,
//     activatedRoute: ActivatedRoute,
//     userService: UserService){
// super(inlineContainerService, activatedRoute, userService);
// }

 tempItems: List<T>
   
   setItems(items){
     this.tempItems = items;
   }

  public isDetailListDisabled(parentValue: number): boolean {
    var parentInvalid = !parentValue || parentValue <= 0;
    var paramExists = this.baseInlineUpdateComponent
      && this.baseInlineUpdateComponent.baseUpdateComponent
      && this.baseInlineUpdateComponent.baseUpdateComponent.Parameters;

    // logika iz templejta, samo tip-sigurno
    return parentInvalid || (paramExists && !this.isParamTrue());
  }
  
  public isParamTrue(): boolean {
    var v = this.getParamValue();
    // pokrij sve varijante koje realno stižu iz Parametara
    return v === true || v === 'true' || v === 1 || v === '1';
  }

  private getParamValue(): any {
    try {
      var biuc = this.baseInlineUpdateComponent;
      if (!biuc || !biuc.baseUpdateComponent || !biuc.baseUpdateComponent.Parameters) return null;

      var p = biuc.baseUpdateComponent.Parameters;
      if (!p.get || p.size === 0) return null;

      var g0 = p.get(0);
      if (!g0 || !g0.get || g0.size === 0) return null;

      var item0 = g0.get(0);
      return item0 ? item0.Value : null;
    } catch (e) {
      return null;
    }
  }
  
}
